export const SET_LANGUAGE = "SET_LANGUAGE";

export const setSelectedLanguage = (dispatch, payload) => {
  dispatch({ type: SET_LANGUAGE, payload });
};
